import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
    Typography,
    Container,
    Table,
    TableBody,
    Link,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';


const VisaInformation = () => {
    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
            <NavigationBar />
            <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
                <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
                    INFORMATIONS SUR LE VISA STATISTIQUE
                </Typography>

                <Typography variant="body1" style={{ marginBottom: '16px' }}>
                    Pour obtenir un visa statistique auprès de l’Institut National de la Statistique du Burundi, il est impératif de fournir les documents suivants :
                </Typography>
                      
                            <TableContainer>
                                <Table style={{ fontSize:'32rem' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ fontWeight: 'bold', color: '#388E3C' }}> <Typography variant="body1">Document </Typography></TableCell>
                                            <TableCell style={{ fontWeight: 'bold', color: '#388E3C' }}> <Typography variant="body1">Description </Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Fiche d'information sur le visa  </Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Obligatoire</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Lettre de Demande de Visa Statistique</Typography></TableCell>
                                            <TableCell>
                                            <Typography variant="body1">
                                                Cette lettre doit être adressée au Directeur Général de l’Institut National de la Statistique (INSBU) et Président du Comité Technique de l’Information Statistique (CTIS). Veuillez vous conformer aux dispositions de l’article  
                                                 <Link href="/documents/ordinances/ordonance540cabsen1643.pdf" target="_blank" rel="noopener noreferrer" color="inherit">
                                                22 de la Loi n°1/18 du 24 juillet 2023
                                           </Link>.</Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Avis d’Éthique </Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Ce document est requis en cas d’enquête ou d’étude biomédicale ou comportementale. </Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Fiche de Renseignement </Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Cette fiche peut être obtenue auprès du Secrétariat du CTIS.</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Documents de l’Enquête </Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Soumettez deux exemplaires de ces documents ainsi qu’une version électronique.</Typography></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Typography variant="h6" style={{ marginTop: '16px', color: '#388E3C' }}>
                                Ces documents de l’enquête doivent inclure :
                            </Typography>

                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ fontWeight: 'bold', color: '#388E3C' }}> <Typography variant="body1">Document </Typography></TableCell>
                                            <TableCell style={{ fontWeight: 'bold', color: '#388E3C' }}> <Typography variant="body1">Description </Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>  <Typography variant="body1">Méthodologie de l’Enquête </Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Énoncez la méthode de collecte, le calendrier de publication, ainsi que les modalités de diffusion et d’archivage des résultats.</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Questionnaires ou Guide d’Entretien</Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Veillez à ce qu’ils soient traduits en kirundi.</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Consentement Éclairé </Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Fournissez-le traduit en kirundi pour toute enquête ou étude biomédicale.</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Manuels</Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Incluez les manuels de l’agent enquêteur, du contrôleur, du superviseur, etc.</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> <Typography variant="body1">Curricula Vitae (CV)</Typography></TableCell>
                                            <TableCell> <Typography variant="body1">Joignez les CV des principaux investigateurs.</Typography></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Typography variant="body1" style={{ marginTop: '16px' }}>
                                <strong>Remarque Importante : </strong>
                                Il est primordial d’inclure tous ces documents dans le dossier de demande de visa statistique et de les envoyer à l’adresse e-mail suivants:
                                <Link href="mailto:ins.burundi@insbu.bi" color="inherit">
                ins.burundi@insbu.bi
              </Link>{' '}
              /{' '}
              <Link href="mailto:ins.burundi2022@gmail.com" color="inherit">
                ins.burundi2022@gmail.com
              </Link>
                            </Typography>
                            <Typography variant="body1" style={{ marginTop: '8px' }}>
                                <strong>Note : </strong>
                                Les documents mentionnés sont obligatoires et doivent être présentés dans leur intégralité. Veuillez  respecter ces exigences afin d’assurer le bon déroulement de votre demande.
                            </Typography>

                            <Typography variant="body1">
                                <strong>Pour plus d’informations, veuillez télécharger le document PDF : </strong>
                                <a href="/documents/visa/Fiche_visa_Insbu.pdf" target="_blank" rel="noopener noreferrer" 
                                    style={{ color: 'green', textDecoration: 'underline' }}>
                                    Télécharger le PDF
                                </a>
                            </Typography>
            </Container>
            <br />
            <br />
            <Footer />
        </div>
    );
};

export default VisaInformation;